import BaseAPI from './base.api';

export default class TireProfileAPI extends BaseAPI {
  getTireProfileLimits = async (): Promise<any> => {
    const response = await this.API.get('tire-profile/limits');
    return response.data;
  };

  setTireProfileLimits = async (payload: any): Promise<any> => {
    const response = await this.API.post('tire-profile/limits', payload);
    return response.data;
  };

  getAxleWiseLimits = async (
    customerId?: string,
    assetId?: string
  ): Promise<any> => {
    const params: Record<string, string> = {};
    if (customerId) params.customerId = customerId;
    if (assetId) params.assetId = assetId;
    const response = await this.API.get('tire-profile/limits/axle-wise', {
      params,
    });
    return response.data;
  };

  setAxleWiseLimits = async (payload: any): Promise<any> => {
    const response = await this.API.post('tire-profile/limits/axle', payload);
    return response.data;
  };

  getAssetTireData = async (
    deviceId: string,
    assetType: string,
    startDate: string,
    endDate: string,
    make: string,
    model: string
  ): Promise<any> => {
    const response = await this.API.get('tire-profile/data', {
      params: {
        deviceId,
        assetType,
        startDate,
        endDate,
        make,
        model,
      },
    });
    return response.data;
  };

  getFleetData = async (): Promise<any> => {
    const response = await this.API.get('tire-profile/fleet');
    return response.data;
  };

  getDashboardData = async (): Promise<any> => {
    const response = await this.API.get('tire-profile/dashboard');
    return response.data;
  };

  // Fetch TPMS sensor battery data for a list of devices
  getBatteryData = async (
    devices: Array<{ deviceId: string; assetType: string }>
  ): Promise<any> => {
    // Backend accepts body; send devices array in request body
    const response = await this.API.post('tire-profile/battery-data', {
      devices,
    });
    return response.data;
  };

  getNotificationsData = async (customerId?: string): Promise<any> => {
    const params = customerId ? { customerId } : {};
    const response = await this.API.get('tire-profile/notifications', {
      params,
    });
    return response.data;
  };

  createAssetTires = async (assetId: string): Promise<any> => {
    const response = await this.API.post(`asset-tire/asset/${assetId}`);
    return response.data;
  };

  removeAssetTires = async (assetId: string): Promise<any> => {
    const response = await this.API.delete(`asset-tire/asset/${assetId}`);
    return response.data;
  };

  getAssetTires = async (assetId: string): Promise<any> => {
    const response = await this.API.get(`asset-tire/asset/${assetId}`);
    return response.data;
  };

  getAssetsTires = async (): Promise<any> => {
    const response = await this.API.get(`asset-tire/assets`);
    return response.data;
  };

  updateTireFitmentDate = async (
    payload: any,
    assetId: string,
    tireCode: string
  ): Promise<any> => {
    const response = await this.API.patch(
      `asset-tire/asset/${assetId}/tireCode/${tireCode}`,
      payload
    );
    return response.data;
  };

  getTireHistory = async (
    assetId: string,
    startDate: string,
    endDate: string,
    changeType?: string
  ): Promise<any> => {
    const response = await this.API.get(`asset-tire-history/asset/${assetId}`, {
      params: {
        startDate,
        endDate,
      },
    });
    return response.data;
  };

  updateAssetTireSensor = async (
    payload: any,
    assetId: string
  ): Promise<any> => {
    const response = await this.API.patch(
      `asset-tire/asset/${assetId}/sensor`,
      payload
    );
    return response.data;
  };

  updateAssetTirePositions = async (
    payload: any,
    assetId: string
  ): Promise<any> => {
    const response = await this.API.patch(
      `asset-tire/asset/${assetId}/swap`,
      payload
    );
    return response.data;
  };

  downloadReport = async (
    startDate: any,
    endDate: string,
    customerCode: string
  ): Promise<any> => {
    const response = await this.API.post(
      `tire-profile/report`,
      {
        startDate,
        endDate,
        customerCode,
      },
      { responseType: 'blob' }
    );
    return response;
  };

  downloadInflationReport = async (customerCode: string): Promise<any> => {
    const response = await this.API.post(
      `tire-profile/report/inflation`,
      { customerCode },
      { responseType: 'blob' }
    );
    return response;
  };
}
